import { render, staticRenderFns } from "./PrisonerVerificationRecords.vue?vue&type=template&id=f59c7e18&"
import script from "./PrisonerVerificationRecords.vue?vue&type=script&lang=js&"
export * from "./PrisonerVerificationRecords.vue?vue&type=script&lang=js&"
import style0 from "./PrisonerVerificationRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports